"use client"

import { useEffect, useState } from "react"
import {
  Box,
  Typography,
  Rating,
  Stack,
} from "@mui/material"
import { useParams } from "react-router-dom"
import axios from "axios"
import PageHeading from "../../layout/PageHeading"
import { DesignBtn } from "../../layout/Common"

export default function CartProduct() {
  const { slug } = useParams();
  const [productDetails, setProductDetials] = useState([]);

  const fetchAllProducts = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_APP}/api/GetProductById?slug=` + slug);
      setProductDetials(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  useEffect(() => {
    fetchAllProducts();
  }, [slug]);

  return (
    <>
      <PageHeading title={'Product Details'} />
      {
        productDetails?.map((item, index) => {
          const discountPercentage = item.DiscountPrice && item.ProductPrice
            ? Math.round(((item.DiscountPrice - item.ProductPrice) / item.DiscountPrice) * 100)
            : null;

          return (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                bgcolor: "black",
                color: "white",
                p: { sm: 8, xs: 2.5 },
                gap: 8,
              }}
            >
              {/* Image Section */}
              <Box sx={{ position: 'relative', flex: 1, overflow: 'hidden', width: "100%", height: { md: "100%", sm: "100%" } }}>
                {/* ✅ Discount Label */}
                {discountPercentage && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 30,
                      right: -38,
                      width: '180px',
                      transform: 'rotate(45deg)',
                      backgroundColor: '#D4AF37', // Golden color
                      color: '#fff',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      fontSize: '20px',
                      py: 1,
                      zIndex: 2,
                      boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                    }}
                  >
                    {discountPercentage}% OFF
                  </Box>
                )}
                <img
                  src={item?.ProductImage}
                  alt="Product"
                  style={{ width: "100%", height: "100%", objectFit: 'cover' }}
                />
              </Box>

              {/* Details Section */}
              <Box sx={{ flex: 1, mt: 5 }}>
                <Typography variant="h3" gutterBottom>
                  {item?.ClothesType}
                </Typography>

                <Typography variant="h6">
                  Our Price : &nbsp;
                  <Typography variant="h3" sx={{ display: 'inline-block' }}> ₹{item?.ProductPrice} </Typography> &nbsp;
                  {item.DiscountPrice && <del>₹{item.DiscountPrice}</del>}
                </Typography>
                {
                  item?.FabricType == "Kurta" ? (
                    <>
                      <Typography variant="h6" sx={{ mt: 4 }}>
                        Kurta Meter : {item?.KurtaMeter}
                      </Typography>
                      <Typography variant="h6">
                        Trouser Meter : {item?.TrouserMeter}
                      </Typography>
                    </>
                  ) : (
                    <>
                      <Typography variant="h6" sx={{ mt: 4 }}>
                        Shirt Meter : {item?.ShirtMeter}
                      </Typography>
                      <Typography variant="h6">
                        Paint Meter : {item?.PaintMeter}
                      </Typography>
                    </>
                  )
                }

                {/* <Rating value={3} readOnly sx={{ my: 5 }} /> */}

                <Typography variant="h6" sx={{mt:5}}>Description :</Typography>
                <Typography variant="h6">{item?.Description}</Typography>

                {/* Add to Cart Button */}
                <Box sx={{ width: { sm: '20%', xs: '100%' }, mt: 3 }}>
                  <DesignBtn width={"100%"} padding={'5px 10px'} text={'Add to cart'} slug={slug} />
                </Box>
              </Box>
            </Box>
          );
        })
      }
    </>
  )
}
